<div class="main-content">
  <app-header [title]="'HEADER.TITLE_LEARNING' | translate" [subtitle]="'HEADER.SUBTITLE_LEARNING' | translate" />

  <div class="row mb-4" style="margin-top: 4rem">
    <div class="col-12 d-flex justify-content-end gap-3">
      <button class="create-learning-button" [routerLink]="['/learning', 'new']" *appHasRole="['ADMIN']">
        {{ 'LEARNING.TO_CREATE_FORM_BUTTON' | translate }}
      </button>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <app-icam-container [iconName]="'learning'" [iconColor]="'white'">
        <app-table
          [allValues$]="allLearning$"
          [type]="'learning'"
          (selectedFilter)="onFilterSelected($event)"
          [hasChart]="false"
          [filters$]="learningFilter$"
          (selectedPage)="onPageSelected($event)"
          [prevPage]="learningPrevPage"
          [currentPage]="learningCurrentPage"
          [nextPage]="learningNextPage"
          [totalPages]="learningTotalPages"
          [hasKeywordFilter]="true"
          [useInlineKeywordFilter]="true"
          [keywordFilterName]="'title'"
          [keywordFilterPlaceholder]="'FILTER.SEARCH_LEARNING'"
          [initialFilters]="learningFilters"
          [isExternalLoading]="isLoadingLanguageChange"
        />
      </app-icam-container>
    </div>
  </div>
</div>
<app-footer-copyright />
